import { Component, Output, ViewChild, Input} from "@angular/core";
import {InsaCronService} from "../../../../insa-services";
import { DeleteActivitiesComponent } from "../insa-job-activities-form/delete-activity.component";
import {InsaChronosJobModel} from '../../../../insa-models';

@Component({
    selector: "delete-job",
    templateUrl: "./delete-job.component.html",
    //styles: [require("./insa-job-form.component.css").toString()]
})
export class DeleteJobComponent {

  
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-job-form/delete-job.component.ts